// import {getters} from './vuex/modules/user';

const appId = 'ulft8mzv';
// User ID: {msp_id}-{username}

export const setIntercomDefaultConfig = () => {
  return {
    app_id: appId,
  };
};

export const setIntercomConfig = data => {
  return {
    app_id: appId,
    username: data['sub_username'],
    user_id: data['user_id'],
    email: data['mail_address'],
    company_name: data['company_name'],
    msp_id: data['msp_id'],
    wave_pro_user: true,
    hide_default_launcher: true,
  };
};
